import { Dispatch, FC, SetStateAction, useEffect, useRef, useState } from 'react';
import { Button, ButtonProps } from '@fluentui/react-components';
import { SearchBox } from "@fluentui/react-search-preview";
import { Dismiss16Regular } from "@fluentui/react-icons";

interface iSearchBar {
	setSearchVal: (val: string) => void;
	searchVal: string;
	columnSearch?: string;
	setLoading?: Dispatch<SetStateAction<boolean>>;
	setCurrentPageNo?: Dispatch<SetStateAction<number>>;
	disabled?:boolean;
}

export const SearchBar: FC<iSearchBar> = (props: any) => {
	const [searchVal, setSearchVal] = useState('');
	var timer: any = useRef(null);

	// let searchData: string = props.columnSearch !== undefined ? `Search ${props.columnSearch}` : "Search" ;
	/** @NOTE : In here it is used as a temporary fix for /troubleshoot/status to show "Search for Solution" as it was undefined and the requirement doesn't need only "Search" to show */
	let searchData: string = window.location.pathname.endsWith("/troubleshoot/status")
		? "Search for Solution"
		: props.columnSearch !== undefined ? `Search ${props.columnSearch}` : "Search";

	const searchHandle = (data: string) => {
		const regex = /^[A-Za-z0-9_-\s]*$/; 													// Accepts alphanumeric, hyphens, and underscores.
		const trimmedData = data.replace(/\s+/g, ' '); 								// Replace multiple spaces with a single space
		if (regex.test(trimmedData)) { setSearchVal(trimmedData); } 	// Update search value with normalized input
	};

	const DismissButton: FC<ButtonProps> = (props: any) =>
		<Button shape="circular"onClick={() => setSearchVal('')} appearance="transparent" icon={<Dismiss16Regular />} size="small" {...props} />

	const search = () => {
		if (timer.current) { clearTimeout(timer.current) }
		timer.current = setTimeout(() => {
			props?.setCurrentPageNo !== undefined && props?.setCurrentPageNo(1);
			props.setSearchVal(searchVal);
			props.setLoading != undefined && props.setLoading(true);
		}, 700);
	}

	useEffect(() => {
		searchVal !== props.searchVal && search();
	}, [searchVal]);

	useEffect(() => {
		props.searchVal.length === 0 && setSearchVal(props.searchVal);
	}, [props.searchVal]);

	return (
		<SearchBox
			size="small"
			disabled={props.disabled}
			dismiss={null}
			contentAfter={<DismissButton aria-label="Clear" />}
			placeholder={searchData}
			value={searchVal}
			onChange={(e: any) => { searchHandle(e.target.value) }}
		/>
	);
}
